import Box from '@mui/material/Box';
import { React, useEffect, useState } from 'react';
import ModalContainer from '../ModalContainer';
import OutlineButton from '../Buttons/outline/OutlinedModalButton';
import Colors from '../../../colors';
import TextInput from '../../TextInput';
import { toTitleCase } from '../../../utils/helpers';

function DoubleTextInputModal({ modalLabel, modalSubLabel, firstInputLabel, firstDefaultValue, firstInputName,
    secondInputLabel, secondDefaultValue, secondInputName, isVisible, setIsVisible, dataCallback }) {
    const [firstTextData, setFirstTextData] = useState(firstDefaultValue);
    const [secondTextData, setSecondTextData] = useState(secondDefaultValue);
    const [firstTextError, setFirstTextError] = useState(false);
    const [secondTextError, setSecondTextError] = useState(false);

    useEffect(() => {
        setFirstTextData(firstDefaultValue);
    }, [firstDefaultValue]);

    useEffect(() => {
        setSecondTextData(secondDefaultValue);
    }, [secondDefaultValue]);

    const saveButtonOnClickHandler = () => {
        const firstError = firstTextData.trim().length === 0;
        const secondError = secondTextData.trim().length === 0;
        if (firstError || secondError) {
            if (firstError) {
                setFirstTextError(true);
                setTimeout(() => {
                    setFirstTextError(false);
                }, 2000)
            }
            if (secondError) {
                setSecondTextError(true);
                setTimeout(() => {
                    setSecondTextError(false);
                }, 2000)
            }
        } else {
            dataCallback({
                [firstInputName]: toTitleCase(firstTextData),
                [secondInputName]: toTitleCase(secondTextData)
            });
            setIsVisible(false);
        }
    };

    return (
        <ModalContainer isVisible={isVisible} setIsVisible={setIsVisible} >
            <Box sx={{
                width: '100%',
                p: 4
            }}>
                <Box sx={{ textAlign: 'center' }}>
                    <h3>{modalLabel}</h3>
                    <h4>{modalSubLabel}</h4>
                </Box>
                <TextInput
                    error={firstTextError}
                    label={firstInputLabel}
                    value={firstDefaultValue}
                    setText={setFirstTextData} />
                <TextInput
                    error={secondTextError}
                    label={secondInputLabel}
                    value={secondDefaultValue}
                    setText={setSecondTextData} />
                <Box sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "5%",
                }}>
                    <OutlineButton
                        onClick={saveButtonOnClickHandler}
                        color={Colors.green}
                        label={'Save'} />
                </Box>
            </Box>
        </ModalContainer>
    );
}

export default DoubleTextInputModal;